import React, { useState } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import CancelConfirmationDrawer from './CancelConfirmationDrawer';
var SorisCancelFlow = function (_a) {
    var sorisReturnCancelRequest = _a.sorisReturnCancelRequest, _b = _a.lineItems, lineItems = _b === void 0 ? [] : _b;
    var _c = useState(false), displayDrawer = _c[0], setDisplayDrawer = _c[1];
    var closeDrawer = function () { return setDisplayDrawer(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card-fix sui-order-1" },
            React.createElement(Button, { onClick: function () { return setDisplayDrawer(true); }, variant: "secondary" }, "Cancel Return")),
        React.createElement(CancelConfirmationDrawer, { displayDrawer: displayDrawer, closeDrawer: closeDrawer, sorisReturnCancelRequest: sorisReturnCancelRequest, lineItems: lineItems })));
};
export default SorisCancelFlow;
